import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { usePageContent } from "@/hooks/usePageContent";
import PixelBlast from "@/components/PixelBlast";

export function ProgrammataPistotitas() {
  const { data, isLoading } = usePageContent("programmata-pistotitas");

  return (
    <div className="page-root">
      <div className="absolute inset-0 z-0 opacity-30">
        <PixelBlast
          variant="circle"
          pixelSize={5}
          color="#00d9d9"
          patternScale={5}
          patternDensity={1.2}
          pixelSizeJitter={0}
          enableRipples
          rippleSpeed={0.4}
          rippleThickness={0.22}
          rippleIntensityScale={3}
          liquid={false}
          liquidStrength={0.12}
          liquidRadius={1.2}
          liquidWobbleSpeed={5}
          speed={0.5}
          edgeFade={0.25}
          transparent
        />
      </div>
      <div className="relative z-10 max-w-[1200px] mx-auto px-8 py-24 min-h-screen">
        {isLoading ? (
          <div className="flex items-center justify-center min-h-screen">
            <div className="animate-pulse text-white/50 text-sm">Loading…</div>
          </div>
        ) : (
          <Card className="bg-white/5 border-white/10">
            <CardHeader>
              <CardTitle className="text-3xl font-bold text-white">{data?.title}</CardTitle>
            </CardHeader>
            <CardContent className="text-white/80">
              {data?.content && <div className="prose prose-invert max-w-none prose-headings:text-white prose-p:text-white/80" dangerouslySetInnerHTML={{ __html: data.content }} />}
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
